/** Зона 200 ₽: Нальчик + Кенже + Шалушка (OSM admin boundaries, simplified) */
export const NALCHIK_STORE_ID = 0;

const NALCHIK_CITY_RING = [
		[43.5411143, 43.4483332],
		[43.5526633, 43.4465437],
		[43.5612269, 43.4508554],
		[43.5589483, 43.444869],
		[43.5538696, 43.4361081],
		[43.5608715, 43.4337065],
		[43.5657249, 43.4362931],
		[43.571772, 43.4430014],
		[43.5792205, 43.4461094],
		[43.5893606, 43.4504207],
		[43.5954492, 43.455123],
		[43.5997219, 43.4601345],
		[43.6035562, 43.4639892],
		[43.6108491, 43.4637653],
		[43.6097078, 43.4626411],
		[43.6076342, 43.4608221],
		[43.6122121, 43.4628294],
		[43.6184451, 43.4603049],
		[43.6216342, 43.462278],
		[43.6311641, 43.4681683],
		[43.636267, 43.4630674],
		[43.6437786, 43.4573445],
		[43.6394495, 43.4410481],
		[43.6402219, 43.4387344],
		[43.6408335, 43.4386877],
		[43.643108, 43.4415934],
		[43.6444706, 43.4437745],
		[43.6473727, 43.4457297],
		[43.6484617, 43.4468202],
		[43.6494058, 43.4481522],
		[43.6483816, 43.4457856],
		[43.6451089, 43.4438602],
		[43.6434513, 43.4407248],
		[43.6419225, 43.438933],
		[43.6460209, 43.4380021],
		[43.6459029, 43.4416946],
		[43.6465305, 43.4394667],
		[43.6472976, 43.4362804],
		[43.6497706, 43.4411727],
		[43.6532521, 43.4387422],
		[43.657136, 43.4399185],
		[43.6541292, 43.4464093],
		[43.6615562, 43.4565443],
		[43.6612505, 43.4653169],
		[43.6656681, 43.4602649],
		[43.6775422, 43.4670222],
		[43.6608052, 43.4857287],
		[43.6526205, 43.4893522],
		[43.6591127, 43.4934989],
		[43.6673579, 43.4980441],
		[43.6776897, 43.5015209],
		[43.681045, 43.5111664],
		[43.6718599, 43.5364936],
		[43.647303, 43.5218155],
		[43.6264408, 43.5222803],
		[43.6187012, 43.5256877],
		[43.6121146, 43.5215971],
		[43.6073206, 43.5194748],
		[43.5977508, 43.5119462],
		[43.6015214, 43.5061824],
		[43.5739607, 43.5003808],
		[43.5715386, 43.4920473],
		[43.568092, 43.4867446],
		[43.5597986, 43.4878314],
		[43.5613824, 43.485176],
		[43.5674261, 43.482162],
		[43.5626645, 43.4736687],
		[43.5623753, 43.4692332],
		[43.565222, 43.4656848],
		[43.5512102, 43.4562172],
		[43.5411143, 43.4483332]
];

const KENJE_RING = [
		[43.5336792, 43.4875347],
		[43.5342707, 43.4874077],
		[43.5354938, 43.487578],
		[43.5369971, 43.4869547],
		[43.5378823, 43.4875989],
		[43.5420236, 43.4877896],
		[43.5432896, 43.4875658],
		[43.5437536, 43.4867134],
		[43.544333, 43.4858708],
		[43.5473531, 43.4847129],
		[43.5523233, 43.4876417],
		[43.5552796, 43.4879999],
		[43.5574839, 43.4894544],
		[43.5587914, 43.4902999],
		[43.5608634, 43.4912436],
		[43.5637307, 43.4930572],
		[43.5658014, 43.4943025],
		[43.5673866, 43.4962541],
		[43.5716017, 43.5000919],
		[43.5693741, 43.5026844],
		[43.5637361, 43.5074468],
		[43.5639493, 43.5080761],
		[43.5648465, 43.5091762],
		[43.5659409, 43.5097384],
		[43.567003, 43.5101586],
		[43.5674241, 43.5112032],
		[43.5661286, 43.5121525],
		[43.5629835, 43.5105125],
		[43.5589121, 43.5102656],
		[43.5565511, 43.5099752],
		[43.5556372, 43.5092905],
		[43.5544181, 43.5086194],
		[43.5520048, 43.507315],
		[43.5506744, 43.5065393],
		[43.5501896, 43.50598],
		[43.5497745, 43.505393],
		[43.5483208, 43.5045],
		[43.5487962, 43.5034344],
		[43.5451877, 43.5014196],
		[43.5439669, 43.5004329],
		[43.5429845, 43.5004961],
		[43.5421463, 43.5007237],
		[43.5406269, 43.5011625],
		[43.5411277, 43.4965946],
		[43.5420638, 43.4945807],
		[43.5414429, 43.4933948],
		[43.5407294, 43.492164],
		[43.5395828, 43.4915394],
		[43.5384536, 43.491232],
		[43.5376301, 43.4903193],
		[43.535935, 43.489611],
		[43.5345402, 43.4888093],
		[43.5339341, 43.4879005],
		[43.5336792, 43.4875347]
];

const SHALUSHKA_RING = [
		[43.517655, 43.5448703],
		[43.521209, 43.540349],
		[43.5216006, 43.5371932],
		[43.5212444, 43.534327],
		[43.5195326, 43.5326652],
		[43.525064, 43.5302354],
		[43.5278401, 43.5269528],
		[43.5292898, 43.5264773],
		[43.5306403, 43.5262206],
		[43.5318299, 43.5262264],
		[43.5320887, 43.5253376],
		[43.5339126, 43.5249603],
		[43.5352242, 43.5239121],
		[43.5367464, 43.5233977],
		[43.5375698, 43.5228201],
		[43.5394862, 43.5228191],
		[43.5410298, 43.5223436],
		[43.5425949, 43.5213487],
		[43.5439937, 43.5210609],
		[43.5453978, 43.5195711],
		[43.5470273, 43.519643],
		[43.5478695, 43.5191111],
		[43.5493863, 43.5183224],
		[43.5506214, 43.5171233],
		[43.5520966, 43.5166613],
		[43.5532098, 43.5159825],
		[43.5528678, 43.5154223],
		[43.5538656, 43.5147969],
		[43.5547413, 43.5142892],
		[43.5559966, 43.5140928],
		[43.5573551, 43.5140451],
		[43.5598133, 43.5133954],
		[43.5610177, 43.5136435],
		[43.5625452, 43.513871],
		[43.5624956, 43.5149029],
		[43.5643329, 43.5156849],
		[43.5660589, 43.5157209],
		[43.5668756, 43.5159854],
		[43.5676561, 43.5166623],
		[43.5689409, 43.5167255],
		[43.571025, 43.5167469],
		[43.5724975, 43.5166676],
		[43.5740197, 43.5171028],
		[43.577292, 43.518548],
		[43.5801941, 43.5197344],
		[43.5828817, 43.5206291],
		[43.5843006, 43.5215685],
		[43.5855934, 43.5216132],
		[43.5885063, 43.5218291],
		[43.591218, 43.5225215],
		[43.5933477, 43.5225876],
		[43.5955176, 43.522117],
		[43.5987872, 43.5222998],
		[43.6018717, 43.5219828],
		[43.6042938, 43.52208],
		[43.6057891, 43.5213235],
		[43.6073716, 43.5218661],
		[43.6101504, 43.5213108],
		[43.6119045, 43.5215014],
		[43.6095757, 43.5254412],
		[43.6069465, 43.5307843],
		[43.5797529, 43.5367079],
		[43.5439427, 43.5427264],
		[43.517655, 43.5448703]
];

const NALCHIK_ZONE_RINGS = [NALCHIK_CITY_RING, KENJE_RING, SHALUSHKA_RING];

const DEFAULT_FIXED_COST = 200;

function pointInRing(lon, lat, ring) {
	let inside = false;
	for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
		const [xi, yi] = ring[i];
		const [xj, yj] = ring[j];
		if (
			(yi > lat) !== (yj > lat) &&
			lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi
		) {
			inside = !inside;
		}
	}
	return inside;
}

/** coords — ymaps [lat, lon] */
export function isInsideNalchikDeliveryZone(coords) {
	if (!coords || coords.length < 2) return false;
	const lat = Number(coords[0]);
	const lon = Number(coords[1]);
	if (!Number.isFinite(lat) || !Number.isFinite(lon)) return false;
	return NALCHIK_ZONE_RINGS.some(ring => pointInRing(lon, lat, ring));
}

export function getNalchikFixedShippingCost(store) {
	const cost = Number(store?.fix_cost_shipping);
	return Number.isFinite(cost) && cost > 0 ? cost : DEFAULT_FIXED_COST;
}

export function getNalchikZoneGeoJson() {
	return {
		type: 'FeatureCollection',
		features: [
			{
				type: 'Feature',
				properties: { name: 'Nalchik', fill: '#ffd21e', 'fill-opacity': 0.25 },
				geometry: { type: 'Polygon', coordinates: [NALCHIK_CITY_RING] },
			},
			{
				type: 'Feature',
				properties: { name: 'Kenje', fill: '#ffd21e', 'fill-opacity': 0.25 },
				geometry: { type: 'Polygon', coordinates: [KENJE_RING] },
			},
			{
				type: 'Feature',
				properties: { name: 'Shalushka', fill: '#ffd21e', 'fill-opacity': 0.25 },
				geometry: { type: 'Polygon', coordinates: [SHALUSHKA_RING] },
			},
		],
	};
}

export function addNalchikZoneToYandexMap(ymaps, map) {
	const zones = ymaps.geoQuery(getNalchikZoneGeoJson()).addToMap(map);
	zones.each(obj => {
		obj.options.set({
			fillColor: obj.properties.get('fill'),
			fillOpacity: obj.properties.get('fill-opacity'),
			strokeColor: '#b3b3b3',
			strokeWidth: 1,
			strokeOpacity: 0.5,
		});
	});
	return zones;
}
